import { parseISO, format, isToday } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
import { capitalize } from 'lodash'

const BR_FORMAT = 'dd/MM/yyyy'

export const formatToBR = (_date) => {
  const date = _date?.replace('T00:00:00.000Z', '')
  const parsed = parseISO(date)
  const formatDate = format(parsed, BR_FORMAT)
  return formatDate
}

export const getDayOfWeek = (date) => {
  const parsed = parseISO(date)

  if (isToday(parsed)) {
    return 'Hoje'
  }

  const day = format(parsed, 'iii', {
    locale: ptBR
  })

  return capitalize(day)
}

export const formatPerExtensed = (date) => {
  const parsed = parseISO(date)

  const formated = format(parsed, `dd 'de' LLLL yyyy`, {
    locale: ptBR
  })

  return formated
}

export const generateArrayOfYears = () => {
  const max = new Date().getFullYear()
  const min = max - 20
  const years = []

  // eslint-disable-next-line no-plusplus
  for (let i = max; i >= min; i--) {
    years.push(String(i))
  }
  return years
}

export default {
  formatToBR,
  generateArrayOfYears
}
